// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NdcC","colMin":"styles_colMin__aIbMj"};